<template>
  <div>
    <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 22/10/2018 11:59AM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li>Please beware, this is work in progress!</li>
          </ul>
        </div>
      </article>
    </div>
    <article class="is-parent box">
    <h1 class="title has-text-centered">Season Totals</h1>
     <season-totals-menu name="time-on-ice"></season-totals-menu>
     <section id="gameFilters">
      <div class="is-parent  is-vertical">
      <article class="is-child box">
        <h2 class="subtitle"><b>Filters</b></h2>
          <div class="columns">
            <div class="column is-3">
              <label class="label">Season</label>
              <div class="control">
                <div class="select">
                  <select v-model="YearSelected" @change="fetchSeasonStats">
                    <option value=2022>2022-2023</option>
                    <option value=2019>2019-2020</option>
                    <option value=2018>2018-2019</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">Competition</label>
              <div class="control">
                <div class="select">
                  <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                    <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-4">
                <label class="label">Opponent</label>
                <div class="control">
                  <div class="select">
                    <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                      <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
            <div class="column is-5">
              <label class="label">Venue</label>
              <div class="control">
                <div class="select">
                  <select v-model="VenueSelected"  @change="fetchSeasonStats">
                    <option v-for="option in VenueOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
                <label class="label">Limit</label>
                <div class="control">
                  <div class="select">
                    <select v-model="LimitSelected" @change="fetchSeasonStats">
                      <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </article>
      <data-table id="Filtered Games" heading="Filtered Games" v-bind:headers="FilterHeadings" v-bind:tableData="GameFilter"></data-table>
      </div>
    </section>
    </article>
   
    <section id="players">
      <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="TimeOnIce" heading="Time On Ice" v-bind:headers="TimeOnIcePlayerHeadings" v-bind:tableData="sortByTimeOnIceData">
          <template slot="filter">
          <label class="label">Sort</label>
          <div class="control">
            <div class="select">
              <select v-model="FilterSelected"  @change="sortByTimeOnIceData">
                <option v-for="option in TimeOnIcePlayerFilters" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
            </div>
          </div>
          </template>
          <div slot="graph">
          </div>
        </data-table>
      </div>
    </section>
  </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import Chart from 'vue-bulma-chartjs'
import _ from 'lodash'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    Chart
  },
  data () {
    return {
      GameFilter: [],
      FilterHeadings: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'avg_shift_game',
      TimeOnIcePlayerData: [],
      TimeOnIcePlayerHeadings: [
        'Player',
        'GP',
        'TOI',
        'Shifts',
        'EH',
        'PP',
        'SH',
        'TOI/Shift',
        'Shifts/G',
        'TOI/G',
        'EH/G',
        'PP/G',
        'SH/G',
        'Goals',
        'Goals/60'
      ],
      TimeOnIcePlayerFilters: [
        {text: 'Player', value: 'player'},
        {text: 'GP', value: 'gp'},
        {text: 'TOI', value: 'total_toi'},
        {text: 'Shifts', value: 'total_shifts'},
        {text: 'EH', value: 'eh_toi_total'},
        {text: 'PP', value: 'pp_toi_total'},
        {text: 'SH', value: 'sh_toi_total'},
        {text: 'TOI/Shift', value: 'avg_shift_length'},
        {text: 'Shifts/G', value: 'avg_shift_count'},
        {text: 'TOI/G', value: 'avg_shift_game'},
        {text: 'EH/G', value: 'eh_toi_avg'},
        {text: 'PP/G', value: 'pp_toi_avg'},
        {text: 'SH/G', value: 'sh_toi_avg'},
        {text: 'Goals', value: 'goals'},
        {text: 'Goals / 60', value: 'goals_sixty'}
      ],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  computed: {
    sortByTimeOnIceData: function () {
      return _.orderBy(this.TimeOnIcePlayerData, this.FilterSelected, ['desc'])
    },
    sortByTimeOnIceDataChart: function () {
      let orderedData = this.sortByTimeOnIceData
      return _.map(orderedData, this.FilterSelected)
    },
    chartData: function () {
      let playerLabels = []
      for (var label of this.sortByTimeOnIceData) {
        playerLabels.push(label.player)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.sortByTimeOnIceDataChart,
        label: 'TimeOnIce - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    }
  },
  methods: {
    fetchSeasonStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/toi', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GameFilter = response.data.games_filter
            this.TimeOnIcePlayerData = response.data.toi
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            this.VenueOptions.push({text: 'Away', value: 'away'})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }
            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            let situations = response.data.situations
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: '--Primary Situations--', value: -6})
            this.SituationOptions.push({text: 'Even Handed', value: -1})
            this.SituationOptions.push({text: 'Power Play', value: -2})
            this.SituationOptions.push({text: 'Short Handed', value: -3})
            this.SituationOptions.push({text: 'Empty Net', value: -4})
            this.SituationOptions.push({text: '--Secondary Situations--', value: -5})
            for (var s = 0; s < situations.length; s++) {
              this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
            }
            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})
          }
        )
    }
  },
  created () {
    this.fetchSeasonStats()
    this.fetchFilterOptions()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
</style>



// WEBPACK FOOTER //
// time-on-ice.vue?5ee3b2a9